import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseurlService} from '../../services/baseurl.service';
import {Observable} from 'rxjs';
import {ConfigAndResult, MetricDescription} from './poi-git-models';

@Injectable({
  providedIn: 'root'
})
export class PoigitService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) { }

  getPoiGitStatus(): Observable<ConfigAndResult[]> {
    return this.http.get<ConfigAndResult[]>(`${this.baseurlService.getBaseUrl()}/poiGit/status`);
  }

  getPoiGitMetrics(): Observable<MetricDescription[]> {
    return this.http.get<MetricDescription[]>(`${this.baseurlService.getBaseUrl()}/poiGit/metrics`);
  }
}
